import axios from 'axios';
import React, { Component } from 'react'
import Seo from './Seo';


import { withTranslation } from 'react-i18next';
import '../css/contactUs.css';


import countries from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import frLocale from "i18n-iso-countries/langs/fr.json";

import { allCountries } from 'country-telephone-data';
import PhoneInput from 'react-phone-input-2';

import 'react-phone-input-2/lib/style.css';

import { isValidPhoneNumber } from 'libphonenumber-js';

// Register locales
countries.registerLocale(enLocale);
countries.registerLocale(frLocale);

const countryList = Object.entries(allCountries).map(([code, data]) => {
  return {
    code: data.iso2.toUpperCase(),
    name: countries.getName(data.iso2.toUpperCase(), "en"),
    dialCode: data.dialCode
  };
}
);


const SUBJECTS = ['remote', 'onsite', 'training', 'audit', 'agency'];

/** Sujet pré-sélectionné via /contactUs?subject=audit (CTA des pages d'offre). */
const subjectFromUrl = () => {
  const asked = new URLSearchParams(window.location.search).get('subject');
  return SUBJECTS.includes(asked) ? asked : 'onsite';
};

const defaultState = {
  organisme: '',
  firstName: '',
  lastName: '',
  email: '',
  country: 'MA',
  subject: 'onsite',
  message: '',
  organismeError: '',
  firstNameError: '',
  lastNameError: '',
  emailError: '',
  messageError: '',
  telError: '',
  messageConfirmation: '',
  messageFailed: '',
  formSubmitted: false,
  phone: '',
  isValidTel: true
}




class ContactUs extends Component {


  constructor(props) {
    super(props)

    this.state = {
      imageContactUs: 'images/cus.jpg',
      organisme: '',
      firstName: '',
      lastName: '',
      country: 'MA',
      subject: subjectFromUrl(),
      message: '',
      organismeError: '',
      firstNameError: '',
      lastNameError: '',
      emailError: '',
      telError: '',
      messageError: '',
      messageConfirmation: '',
      messageFailed: '',
      formSubmitted: false,
      phone: '',
      isValidTel: true
    }
  }

  handleOrganismeChange = (event) => {
    this.setState({
      organisme: event.target.value,
      organismeError: null,
      formSubmitted: false,
      messageConfirmation: null,
      messageFailed: null
    })
  }

  handleFirstNameChange = (event) => {
    this.setState({
      firstName: event.target.value,
      firstNameError: null,
      formSubmitted: false,
      messageConfirmation: null,
      messageFailed: null
    })
  }

  handleLastNameChange = (event) => {
    this.setState({
      lastName: event.target.value,
      lastNameError: null,
      formSubmitted: false,
      messageConfirmation: null,
      messageFailed: null
    })
  }

  handleEmailChange = (event) => {
    this.setState({
      email: event.target.value,
      emailError: null,
      messageConfirmation: null,
      messageFailed: null
    })
  }

  handleMessageChange = (event) => {
    this.setState({
      message: event.target.value,
      messageError: null,
      messageConfirmation: null,
      messageFailed: null
    })
  }

  handleCountryChange = event => {
    this.setState({
      country: event.target.value,
      messageConfirmation: null,
      messageFailed: null
    });
    const pays = countryList.find((c) => c.code === event.target.value);

    if (pays) {
      this.setState({
        phone: pays.dialCode
      })
    }
  }

  handlePhoneChange = (value) => {
    const isValid = isValidPhoneNumber(value, this.state.country);
    this.setState(
      {
        phone: value,
        isValidTel: isValid
      }
    )
  }

  handleSubjectChange = (event) => {
    this.setState({
      subject: event.target.value,
      messageConfirmation: null,
      messageFailed: null
    })
  }
  handleSubmit = event => {
    event.preventDefault();
    const isValid = this.validate();
    if (isValid) {
      let formData = new FormData();
      formData.append('telNumber', this.state.phone);
      formData.append('prenom', this.state.firstName);
      formData.append('nom', this.state.lastName);
      formData.append('pays', this.state.country);
      formData.append('message', this.state.message);
      formData.append('email', this.state.email);
      formData.append('purpose', this.state.subject);
      const config = {
        headers: { 'content-type': 'multipart/form-data' }
      }
      let url = `${process.env.REACT_APP_API_URL}/saveContact`;
      axios.post(url, formData)
        .then(response => {
          if (response.data.returnCode === 'OK') {
            this.setState(defaultState);
            this.setState({
              messageConfirmation: this.props.t('message_confirmation'),
              messageFailed: null,
              formSubmitted: true

            })
          } else {
            this.setState(defaultState);
            this.setState({
              messageConfirmation: null,
              messageFailed: this.props.t('service_failed'),
              formSubmitted: true

            })
          }
        })
        .catch(error => {
          this.setState(defaultState);
          this.setState({
            messageConfirmation: null,
            messageFailed: this.props.t('service_failed'),
            formSubmitted: true

          })
        });

    }
  }

  validate = () => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    let organismeError = "";
    let messageError = "";
    let firstNameError = "";
    let lastNameError = "";
    let emailError = "";

    if (!this.state.firstName) {
      firstNameError = this.props.t('firstName_mandatory')
    }
    if (!this.state.lastName) {
      lastNameError = this.props.t('lastName_mandatory');
    }


    if (!this.state.email) {
      emailError = this.props.t('email_mandatory');
    } else if (!emailRegex.test(this.state.email)) {
      emailError = this.props.t('email_invalid'); // Ajoute ce message dans ton fichier JSON
    }
    if (!this.state.message) {
      messageError = this.props.t('message_mandatory');
    }

    if (!isValidPhoneNumber(this.state.phone, this.state.country)) {
      this.setState({
        isValidTel: false
      })
    }

    if (firstNameError || lastNameError || emailError || messageError || !isValidPhoneNumber(this.state.phone, this.state.country)) {
      this.setState({
        firstNameError,
        lastNameError,
        emailError,
        messageError
      });
      return false;
    }

    return true;
  }

  render() {
    const { t, i18n } = this.props;

    // Get country names in the current language
    const countryNames = Object.entries(countries.getNames(i18n.language))
      .map(([code, name]) => ({ code, name }));
    return (
      <div className="contactUs-container">
        <Seo
          title="Contact"
          description="Contactez YB Technical Services pour vos projets de conseil, développement et formation IT au Maroc."
          path="/contactUs"
        />
        {/* Conteneur principal avec alignement horizontal */}
        <div className="flex space-x-4">
          {/* Premier div enfant */}
          <div className="w-1/2 bg-gray-300 p-4">
            <img
              src={this.state.imageContactUs}
              alt="Contact Us"
              className="w-full h-auto rounded-lg shadow-lg"
            />
          </div>

          {/* Deuxième div enfant */}
          <div className="w-1/2 bg-gray-100 p-6 rounded-lg shadow-lg">
            <h2 className="text-2xl font-bold text-center mb-4">{this.props.t('contact_us')}</h2>
            <p className="text-center mb-6">{this.props.t('leave_message')}</p>

            {this.state.messageConfirmation && (
              <div className="bg-green-100 border border-green-400 text-green-700 px-4 py-3 rounded mb-4">
                {this.state.messageConfirmation}
              </div>
            )}

            {this.state.messageFailed && (
              <div className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded mb-4">
                {this.state.messageFailed}
              </div>
            )}

            <form onSubmit={this.handleSubmit}>
              {/* Prénom */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">{this.props.t('label_first_name')}</label>
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={this.state.firstName}
                  onChange={this.handleFirstNameChange}
                  placeholder={this.props.t('placeholder_first_name')}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
                {
                  this.state.firstNameError ? (
                    <div className="text-red-500 text-sm mt-2">{this.state.firstNameError}</div>
                  ) : null
                }
              </div>

              {/* Nom */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">{this.props.t('label_last_name')}</label>
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={this.state.lastName}
                  onChange={this.handleLastNameChange}
                  placeholder={this.props.t('placeholder_last_name')}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
                {
                  this.state.lastNameError ? (
                    <div className="text-red-500 text-sm mt-2">{this.state.lastNameError}</div>
                  ) : null
                }
              </div>

              {/* Email */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">{this.props.t('label_email')}</label>
                <input
                  type="text"
                  id="email"
                  name="email"
                  value={this.state.email}
                  onChange={this.handleEmailChange}
                  placeholder={this.props.t('placeholder_email')}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                />
                {
                  this.state.emailError ? (
                    <div className="text-red-500 text-sm mt-2">{this.state.emailError}</div>
                  ) : null
                }
              </div>

              {/* Pays */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">{this.props.t('label_country')}</label>
                <select
                  id="country"
                  name="country"
                  value={this.state.country}
                  onChange={this.handleCountryChange}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                >
                  {countryNames.map(({ code, name }) => (
                    <option key={code} value={code}>{name}</option>
                  ))}
                </select>
              </div>

              {/* Telephone */}
              <div className="mb-4 w-full max-w-xs sm:max-w-sm md:max-w-md">
                <label className="block text-sm font-medium text-gray-700">
                  {this.props.t('label_phone')}
                </label>
                <PhoneInput
                  country={this.state.country.toLocaleLowerCase()}
                  value={this.state.phone}
                  onChange={this.handlePhoneChange}
                  enableSearch={true}
                  disableDropdown={true}
                  placeholder={this.props.t('placeholder_phone')}
                  inputStyle={{ width: '100%' }} // Ensure full width
                />
                {!this.state.isValidTel && (
                  <div className="text-red-500 text-sm mt-2">
                    {this.props.t('invalid_phone_number')}
                  </div>
                )}
              </div>




              {/* Objet */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">{this.props.t('label_subject')}</label>
                <select
                  id="subject"
                  name="subject"
                  value={this.state.subject}
                  onChange={this.handleSubjectChange}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                >
                  <option value="audit">{this.props.t('subject_audit')}</option>
                  <option value="agency">{this.props.t('subject_agency')}</option>
                  <option value="remote">{this.props.t('subject_remote')}</option>
                  <option value="onsite">{this.props.t('subject_onsite')}</option>
                  <option value="training">{this.props.t('subject_training')}</option>
                </select>
              </div>

              {/* Message */}
              <div className="mb-4">
                <label className="block text-sm font-medium text-gray-700">{this.props.t('label_message')}</label>
                <textarea
                  id="message"
                  name="message"
                  value={this.state.message}
                  onChange={this.handleMessageChange}
                  placeholder={this.props.t('placeholder_message')}
                  className="mt-1 block w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500"
                  style={{ height: '150px' }}
                ></textarea>
                {
                  this.state.messageError ? (
                    <div className="text-red-500 text-sm mt-2">{this.state.messageError}</div>
                  ) : null
                }
              </div>

              {/* Bouton d'envoi */}
              <div className="flex justify-center">
                <div
                  onClick={this.handleSubmit}
                  type="submit"
                  className="contact-button"
                >
                  {this.props.t('send_button')}
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(ContactUs);